import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('view-logs');

const ViewLogs = () => (
  <div className={bem()}>
    <StepTitle>View Logs</StepTitle>
    <Paragraph>
      Holy smokes! You just started this thing a few minutes ago and you've
      already got a real app deployed. Good job! Ok, what's next? Let's go ahead
      and find out how to look at our logs.
    </Paragraph>
    <Paragraph>
      If you haven't already, go create a Zap with your shiny new app. This will
      generate some log data for us to look at. In your terminal execute
    </Paragraph>
    <BashCodeBlock
      lines={[{ content: 'zapier logs --type=http', isCommand: true }]}
    />
    <Paragraph>
      This will show you a bit of info on recent HTTP traffic to your API. If
      you want get more detailed info use
    </Paragraph>
    <BashCodeBlock
      lines={[
        { content: 'zapier logs --type=http --detailed', isCommand: true },
      ]}
    />
    <Paragraph>
      In your code you can use z.console.log("my debug message") to add your own
      debug messages, and check them with
    </Paragraph>
    <BashCodeBlock
      lines={[{ content: 'zapier logs --type=console', isCommand: true }]}
    />
    <Paragraph>
      For all of the commands in the CLI the help command is super useful to
      find out what options are available. Execute the following to see other
      things you can do with zapier logs
    </Paragraph>
    <BashCodeBlock lines={[{ content: 'zapier help logs', isCommand: true }]} />
  </div>
);

export default ViewLogs;
